
/* injects from baggage-loader */

'use strict';

const moduleButtonActionsInitializer = angular.module('button_actions.initializer', []);

moduleButtonActionsInitializer.service('ButtonActionsManager', [
  '$timeout', '$injector', 'ns', '$translate',
  ($timeout, $injector, ns, $translate) => {
    let Y;

    return {
      init(y) {
        Y = y;
      },

      updateOptions(widget) {
        const options = window.justclick;
        const linkHref = widget.button_attributes.link_href;
        const isDefaultValue = linkHref === '' || linkHref === '#' || linkHref === 'http://' || linkHref === 'http://#' || linkHref === null;

        if (options && options.useNextPageUrl && isDefaultValue) {
          widget.button_attributes.link_href_target = 'next';
          widget.button_attributes.link_href = '#nextPage';
        }

        // В случае обычного конструктора писем включим по умолчанию опцию "open_link"
        if (window.Editor.mode === 'email.page.editor' && !options.useNextPageUrl) {
          widget.button_attributes.click_action = 'open_link';
        }

        // Если в конструкторе писем включена внутренняя ссылка, то переключим ее на внешнюю
        if (window.Editor.mode === 'email.page.editor' && widget.button_attributes.link_href_target === 'none') {
          widget.button_attributes.link_href_target = 'blank';
        }
      },

      destroy() {

      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/buttonActions/buttonActions.initializer.js